import { createAction } from 'deox';
import { REMOVE_TLT_WIDGET_CONFIG, SET_TLT_WIDGET_CONFIG } from './types';

export const setTlTWidgetConfig = createAction(SET_TLT_WIDGET_CONFIG, (res) => (params) => res(params));
export const removeTlTWidgetConfig = createAction(REMOVE_TLT_WIDGET_CONFIG);
